// JavaScript Document

 


jQuery(document).ready(function($) {
    "use strict";

  

    // Bestseller owl slider script
    $("#nav-bestseller .next").click(function() {
        $("#owl-bestseller").trigger('owl.next');
    });
    $("#nav-bestseller .prev").click(function() {
        $("#owl-bestseller").trigger('owl.prev');
    });

    $("#owl-bestseller").owlCarousel({
        // Most important owl features
        items: 4,
        itemsCustom: false,
        itemsDesktop: [1199, 3],
        itemsDesktopSmall: [980, 2],
        itemsTablet: [768,2],
        itemsTabletSmall: false,
        itemsMobile: [479, 1],
        singleItem: false,
        itemsScaleUp: false,
        responsive: true,
        responsiveRefreshRate: 200,
        responsiveBaseWidth: window,
        autoPlay: true,
        stopOnHover: true,
        navigation: false
    });

    // Summer sale owl slider script
    $("#nav-summer-sale .next").click(function() {
        $("#owl-summer-sale").trigger('owl.next');
    });
    $("#nav-summer-sale .prev").click(function() {
        $("#owl-summer-sale").trigger('owl.prev');
    });

    $("#owl-summer-sale").owlCarousel({
        // Most important owl features
      items: 3,
        itemsCustom: false,
        itemsDesktop: [1199, 2],
        itemsDesktopSmall: [980, 2],
        itemsTablet: [768,2],
        itemsTabletSmall: false,
        itemsMobile: [479, 1],
        singleItem: false,
        itemsScaleUp: false,
        responsive: true,
        responsiveRefreshRate: 200,
        responsiveBaseWidth: window,
        autoPlay: false,
        stopOnHover: false,
        navigation: false
    });

  // Summer sale owl slider script
    $("#nav-summer-sale-nosidebar .next").click(function() {
        $("#owl-summer-sale-nosidebar").trigger('owl.next');
    });
    $("#nav-summer-sale-nosidebar .prev").click(function() {
        $("#owl-summer-sale-nosidebar").trigger('owl.prev');
    });

    $("#owl-summer-sale-nosidebar").owlCarousel({
        // Most important owl features
        items: 4,
        itemsCustom: false,
        itemsDesktop: [1199, 3],
        itemsDesktopSmall: [980, 2],
        itemsTablet: [768,2],
        itemsTabletSmall: false,
        itemsMobile: [479, 1],
        singleItem: false,
        itemsScaleUp: false,
        responsive: true,
        responsiveRefreshRate: 200,
        responsiveBaseWidth: window,
        autoPlay: false,
        stopOnHover: false,
        navigation: false
    });
  
    // iphone(ios) owl slider script
    $("#nav-child .next").click(function() {
        $("#owl-child").trigger('owl.next');
    });
    $("#nav-child .prev").click(function() {
        $("#owl-child").trigger('owl.prev');
    });

    $("#owl-child").owlCarousel({
        // Most important owl features
        items: 3,
        itemsCustom: false,
        itemsDesktop: [1199, 2],
        itemsDesktopSmall: [980, 2],
        itemsTablet: [768,2],
        itemsTabletSmall: false,
        itemsMobile: [479, 1],
        singleItem: false,
        itemsScaleUp: false,
        responsive: true,
        responsiveRefreshRate: 200,
        responsiveBaseWidth: window,
        autoPlay: false,
        stopOnHover: false,
        navigation: false
    });
  
  
    // iphone(ios) owl slider script
    $("#nav-child-nosidebar .next").click(function() {
        $("#owl-child-nosidebar").trigger('owl.next');
    });
    $("#nav-child-nosidebar .prev").click(function() {
        $("#owl-child-nosidebar").trigger('owl.prev');
    });

    $("#owl-child-nosidebar").owlCarousel({
        // Most important owl features
        items: 4,
        itemsCustom: false,
        itemsDesktop: [1199, 3],
        itemsDesktopSmall: [980, 2],
        itemsTablet: [768,2],
        itemsTabletSmall: false,
        itemsMobile: [479, 1],
        singleItem: false,
        itemsScaleUp: false,
        responsive: true,
        responsiveRefreshRate: 200,
        responsiveBaseWidth: window,
        autoPlay: false,
        stopOnHover: false,
        navigation: false
    });
  

    // owl slider script
    $("#nav-tabs .next").click(function() {
        $("#owl-new").trigger('owl.next');
        $("#owl-featured").trigger('owl.next');
    });
    $("#nav-tabs .prev").click(function() {
        $("#owl-new").trigger('owl.prev');
        $("#owl-featured").trigger('owl.prev');
    });

    $("#owl-new").owlCarousel({
        // Most important owl features
        items: 3,
        itemsCustom: false,
        itemsDesktop: [1199, 3],
        itemsDesktopSmall: [980, 2],
        itemsTablet: [768,2],
        itemsTabletSmall: false,
        itemsMobile: [479, 1],
        singleItem: false,
        itemsScaleUp: false,
        responsive: true,
        responsiveRefreshRate: 200,
        responsiveBaseWidth: window,
        autoPlay: false,
        stopOnHover: false,
        navigation: false
    });
    $("#owl-featured").owlCarousel({
        // Most important owl features
        items: 3,
        itemsCustom: false,
        itemsDesktop: [1199, 3],
        itemsDesktopSmall: [980, 2],
        itemsTablet: [768,2],
        itemsTabletSmall: false,
        itemsMobile: [479, 1],
        singleItem: false,
        itemsScaleUp: false,
        responsive: true,
        responsiveRefreshRate: 200,
        responsiveBaseWidth: window,
        autoPlay: false,
        stopOnHover: false,
        navigation: false
    });

    // owl slider script
    $("#nav-tabs2 .next").click(function() {
        $("#owl-new2").trigger('owl.next');
        $("#owl-featured2").trigger('owl.next');
    });
    $("#nav-tabs2 .prev").click(function() {
        $("#owl-new2").trigger('owl.prev');
        $("#owl-featured2").trigger('owl.prev');
    });

    $("#owl-new2").owlCarousel({
        // Most important owl features
        items: 3,
        itemsCustom: false,
        itemsDesktop: [1199, 2],
        itemsDesktopSmall: [980, 2],
        itemsTablet: [768,2],
        itemsTabletSmall: false,
        itemsMobile: [479, 1],
        singleItem: false,
        itemsScaleUp: false,
        responsive: true,
        responsiveRefreshRate: 200,
        responsiveBaseWidth: window,
        autoPlay: false,
        stopOnHover: false,
        navigation: false
    });
    $("#owl-featured2").owlCarousel({
        // Most important owl features
         items:3,
        itemsCustom: false,
        itemsDesktop: [1199, 2],
        itemsDesktopSmall: [980, 2],
        itemsTablet: [768,2],
        itemsTabletSmall: false,
        itemsMobile: [479, 1],
        singleItem: false,
        itemsScaleUp: false,
        responsive: true,
        responsiveRefreshRate: 200,
        responsiveBaseWidth: window,
        autoPlay: false,
        stopOnHover: false,
        navigation: false
    });


  
   // owl slider script
    $("#nav-tabs3 .next").click(function() {
        $("#owl-new3").trigger('owl.next');
        $("#owl-featured3").trigger('owl.next');
    });
    $("#nav-tabs3 .prev").click(function() {
        $("#owl-new3").trigger('owl.prev');
        $("#owl-featured3").trigger('owl.prev');
    });

    $("#owl-new3").owlCarousel({
        // Most important owl features
        items: 4,
        itemsCustom: false,
        itemsDesktop: [1199, 3],
        itemsDesktopSmall: [980, 2],
        itemsTablet: [768, 2],
        itemsTabletSmall: false,
        itemsMobile: [479, 1],
        singleItem: false,
        itemsScaleUp: false,
        responsive: true,
        responsiveRefreshRate: 200,
        responsiveBaseWidth: window,
        autoPlay: false,
        stopOnHover: false,
        navigation: false
    });
    $("#owl-featured3").owlCarousel({
        // Most important owl features
         items:4,
        itemsCustom: false,
        itemsDesktop: [1199, 3],
        itemsDesktopSmall: [980, 2],
        itemsTablet: [768,2],
        itemsTabletSmall: false,
        itemsMobile: [479, 1],
        singleItem: false,
        itemsScaleUp: false,
        responsive: true,
        responsiveRefreshRate: 200,
        responsiveBaseWidth: window,
        autoPlay: false,
        stopOnHover: false,
        navigation: false
    });
  
  


    $("#owl-partners").owlCarousel({
        // Most important owl features
        items: 5,
        itemsCustom: false,
        itemsDesktop: [1199, 4],
        itemsDesktopSmall: [980, 2],
        itemsTablet: [630, 1],
        itemsTabletSmall: false,
        itemsMobile: [479, 1],
        singleItem: false,
        itemsScaleUp: false,
        responsive: true,
        responsiveRefreshRate: 200,
        responsiveBaseWidth: window,
        autoPlay: true,
        stopOnHover: false,
        navigation: false
    });
    $("#owl-home-slider").owlCarousel({
        // Most important owl features
        items: 1,
        itemsCustom: false,
        itemsDesktop: [1199, 1],
        itemsDesktopSmall: [980, 1],
        itemsTablet: [630, 1],
        itemsTabletSmall: false,
        itemsMobile: [479, 1],
        singleItem: false,
        itemsScaleUp: false,
        responsive: true,
        responsiveRefreshRate: 200,
        responsiveBaseWidth: window,
        autoPlay: true,
        stopOnHover: false,
        navigation: false
    });

    $(function() {
        $('.dropdown').hover(function() {
            $(this).addClass('open');
        }, function() {
            $(this).removeClass('open');
        });
    });

    // jPages paginated blocks
    var $holder = $("body").find(".holder");
    if (!$holder.length) {
        $("body").append("<div class='holder'></div>");
    }
    $("div.holder").jPages({
        containerID: "products",
        previous: ".feature-block a[data-role='prev']",
        next: ".feature-block a[data-role='next']",
        animation: "fadeInRight",
        perPage: 4
    });


   $('input,textarea').not('.email-modal__input').focus(function() {
      $(this).data('placeholder', $(this).attr('placeholder'))
      $(this).attr('placeholder', '');
  });
  $('input,textarea').not('.email-modal__input').blur(function() {
      $(this).attr('placeholder', $(this).data('placeholder'));
  });
  
  
    $('.revolution').revolution({
        delay: 5000,
        startwidth: 1170,
        startheight: 500,
        hideThumbs: 10,
        fullWidth: "on",
        fullScreen: "on",
        navigationType: "none",
        navigationArrows: "solo",
        navigationStyle: "round",
        navigationHAlign: "center",
        navigationVAlign: "bottom",
        navigationHOffset: 30,
        navigationVOffset: 30,
        soloArrowLeftHalign: "left",
        soloArrowLeftValign: "center",
        soloArrowLeftHOffset: 20,
        soloArrowLeftVOffset: 0,
        soloArrowRightHalign: "right",
        soloArrowRightValign: "center",
        soloArrowRightHOffset: 20,
        soloArrowRightVOffset: 0,
        touchenabled: "on"

    });

    $('.tool_tip').tooltip();




   
    // Daily Deal CountDown Clock Settings
    var date = new Date().getTime();			// This example is just to show how this function works.
    var new_date = new Date(date + 86400000);	// You can set your own time whenever you want.
//    var n = new_date.toUTCString();				// 'date' value is given in milliseconds.
    //alert(new_date)
    $(".time").countdown({
        leadingZero: true,
   //    "date" : "september 30, 2014"
      "date" : "December 30, 2015"

    });


    // Categories Menu Manipulations
    $(".ul-side-category li a").click(function() {

        var sm = $(this).next();
        if (sm.hasClass("sub-category")) {
            if (sm.css("display") === "none") {
                $(this).next().slideDown();
            }
            else {

                $(this).next().slideUp();

                $(this).next().find(".sub-category").slideUp();


                /*$(this).next().find(".categories-submenu").slideUp("normal", function() {
                 $(this).parent().find(".icon-angle-down").removeClass("icon-angle-down").addClass("icon-angle-right");
                 });*/
            }

            return false;
        }
        else {
            return true;
        }
    });





});

new WOW().init();



document.addEventListener("DOMContentLoaded", function() {
	window.onscroll = function(ev) {
      if (window.scrollY >= 1) {
      	document.getElementById("header").classList.remove("header-top-fixed");
      }
	};
});


  